import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var MenuListItemWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var MainCategoryWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  padding: ", "px;\n  cursor: pointer;\n  background-color: ", ";\n  min-height: ", "px;\n  align-items: center;\n  &:hover {\n    ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding: ", "px;\n  cursor: pointer;\n  background-color: ", ";\n  min-height: ", "px;\n  align-items: center;\n  &:hover {\n    ", ";\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs;
}, function (props) {
  var _a;

  return props.isOpen ? props.backgroundColor : (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xl;
}, function (props) {
  return props.hoverBackground && "background:".concat(props.hoverBackground);
});
var NestedWrapper = styled(MainCategoryWrapper)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  ", "\n"], ["\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n  ", "\n"])), function (props) {
  var _a;

  return props.nested ? 0 : "".concat((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs, "px");
}, function (props) {
  return props.iconWidth && "* {\n      min-width: ".concat(props.iconWidth, "px;\n    }");
});
var HeaderWrapper = styled(MainCategoryWrapper)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-left: ", "px;\n  &:hover {\n    text-decoration: underline;\n  }\n  ", "\n"], ["\n  padding-left: ", "px;\n  &:hover {\n    text-decoration: underline;\n  }\n  ", "\n"])), function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.iconWidth && "* {\n      min-width: ".concat(props.iconWidth, "px;\n    }");
});
styled(MainCategoryWrapper)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding-left: ", "px;\n  align-self: flex-start;\n"], ["\n  padding-left: ", "px;\n  align-self: flex-start;\n"])), function (props) {
  return props.paddingLeft;
});
var HeaderText = styled.h2(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", "px;\n"], ["\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", "px;\n"])), function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s4;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.weight.semiBold;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.lineHeight.m2;
});
var BodyText = styled.p(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  gap: ", "px;\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", "px;\n  color: ", ";\n"], ["\n  display: flex;\n  gap: ", "px;\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", "px;\n  color: ", ";\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s2;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.weight.regular;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.lineHeight.s2;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.black;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
export { BodyText, HeaderText, HeaderWrapper, MainCategoryWrapper, MenuListItemWrapper, NestedWrapper };